<template>
  <f7-page name="predpoved-pocasia" @page:init="onPageInit" class="bg-pocasie">
    <f7-navbar>
      <f7-nav-left>
        <f7-link icon-ios="f7:menu" icon-aurora="f7:menu" icon-md="material:menu" panel-open="left"></f7-link>
      </f7-nav-left>
      <f7-nav-title sliding>Modelová predpoveď</f7-nav-title>
      <f7-nav-right>
        <f7-link icon-ios="f7:arrow_2_circlepath" icon-aurora="f7:arrow_2_circlepath" icon-md="material:autorenew" @click="pageReload($event,false) " href="#" ></f7-link>
        <f7-link icon-ios="f7:arrow_left" icon-aurora="f7:arrow_left" icon-md="material:arrow_back" @click="$f7router.back()" href="#" ></f7-link>
      </f7-nav-right>
    </f7-navbar>
    <template v-if="isStationsLoaded">
      <f7-list class="ss-list">
        <f7-list-item title="Mesto:"
                      class="predpoved-pocasia-ss-list"
                      smart-select
                      :smart-select-params="{openIn: 'popup', scrollToSelectedItem:true, closeOnSelect: true, pageTitle:'Vyberte mesto', popupCloseLinkText:'Návrat', searchbar: {  removeDiacritics:true, customSearch: true, on: { search: searchFromBeginning }, }, searchbarPlaceholder: 'Hľadať...'}">
          <select name="station" v-model="selected_station_id" @change="onSelectCity($event)">
            <option v-for="(value, key) in stations" :key="key" :value="value.station_id">{{ value.station_name }}</option>
          </select>
          <div slot="root-start" class="float-left" style="margin: 3px;" v-if="isGeolocationEnabled">
            <f7-button @click="selectStationByLocation" class="text-color-black" icon-f7="placemark_fill"></f7-button>
          </div>
        </f7-list-item>
      </f7-list>
      <f7-block v-if="isDataLoaded" class="margin-top-half predpoved-cards">

        <div class="predpoved-pocasia-main">


          <template v-for="(item, key) in stationData.forecasts">

            <div  class="no-margin-left mt-1 mb-1 no-margin-right no-border">

              <div class="tile">
                <div class="title mb-1"><span class="text-capitalize">{{ item.dt_forecast*1000 | moment('dddd') }}</span><br>
                  <span class="small">{{ item.dt_forecast*1000 | moment('DD.MM.YYYY') }}</span></div>

                <shmu-forecast-icon :icon-id="item.icon_id" icon-class="predpoved-icon-size"></shmu-forecast-icon>
                <div class="font-weight-bold fs-1-25 text-uppercase text-align-center">{{ item.pocasie }}</div>

                <div class="wind margin-top-half" v-if="item.v_rychlost !== null" >
                  <div style="padding: 0px 10px">
                    Vietor: <img src="static/shmu/img/svg/wind.svg" :class="'img-wind rot-'+item.v_smer.toLowerCase()"> <strong>{{ item.v_rychlost | windKmh }}km/h</strong>
                  </div>
                </div>

                <div class="temps">
                  <div class="temp_black"><span class="small">min.</span><br>{{ item.t_min }}°C</div>
                  <div class="temp_white"><span class="small">max.</span><br>{{ item.t_max }}°C</div>
                </div>
              </div>

            </div>

          </template>


        </div>
      </f7-block>

    </template>
  </f7-page>
</template>
<script>
  import Axios from "axios";

  import shmuForecastIcon from "../components/shmu-forecast-icon";
  import SHMUconf from "../js/SHMUconf";
  import searchMixin from "../js/mixin";
  import geoLocationMixin from "../js/geoLocationMixin";

  export default {
    components: {
      'shmu-forecast-icon': shmuForecastIcon
    },
    mixins: [searchMixin,
      geoLocationMixin],
    data: function () {
      return {
        // products: this.$f7.data.products, // ziskanie udajov z globalneho data
        stations: [],
        stationData: [],
        selected_station_id: null,
        isStationsLoaded: false,
        isDataLoaded: false,
        lastUpdated: 0,
        tCheckInterval: null,
      };
    },
    filters: {
      windKmh: function (val) {
        if (val) {
          return Math.round(val * 3.6 * 10) / 10;
        }
        return null;
      },
    },
    mounted() {
      const self = this;
      // otvorime hlavne menu
      this.$f7.accordion.close('.shmu-i-pocasie');
      this.$f7.accordion.open('.shmu-i-pocasie');
    },
    updated() {
      if (this.selected_station_id === null && this.stations.length > 0) {
        this.$f7.smartSelect.get('.predpoved-pocasia-ss-list .smart-select').open();
      }
    },
    destroy() {
      clearInterval(this.tCheckInterval);
    },
    methods: {
      onPageInit() {
        this.pageReload(null, true)
      },
      pageReload(event, isInit) {
        const self = this;

        if (isInit || (this.$moment().unix() - this.lastUpdated) > 60) { // ak posledne stiahnutie bolo menej ako 1 min, tak nedovolime refresh


          let cached_stations = self.$ls.get('forecast_weather_stations');
          if (cached_stations !== null) {
            self.stations = cached_stations;
            self.selected_station_id = this.$ls.get('forecast_weather_station_id');
            self.isStationsLoaded = true;
            self.loadStationData();
          } else {

            self.$f7.dialog.preloader('Načítavam...');

            Axios.get(SHMUconf.API_BASE_URL + 'meteo/getforecastweatherstations', {
              crossDomain: true,
              cache: false,
            })
                    .then((response) => {
                      if (!response.data.error) {
                        self.stations = response.data;
                        self.selected_station_id = this.$ls.get('forecast_weather_station_id');
                        self.isStationsLoaded = true;
                        self.$ls.set('forecast_weather_stations', self.stations, 2 * 24 * 60 * 60 * 1000); // 2 dni
                        self.loadStationData();
                      } else {
                        self.$f7.dialog.alert('Nepodarilo sa načítať zoznam staníc pre predpoveď počasia', 'Nastala chyba');
                      }

                      self.$f7.dialog.close();
                    }).catch((error) => {
              self.$f7.dialog.close();
              self.$f7.dialog.alert('Nepodarilo sa nadviazať spojenie so serverom SHMÚ', 'Nastala chyba spojenia');
            });
          }
        }

      },
      onSelectCity(event) {
        this.selected_station_id = parseInt(event.target.value);
        this.loadStationData();
        this.$ls.set('forecast_weather_station_id', this.selected_station_id);
      },
      loadStationData() {
        const self = this;

        if (this.selected_station_id === null) {
          // ak nie je vybrana stanica, nic nerobime, v updated funkcii sa otvori vyber stanic
        } else {
          self.$f7.dialog.preloader('Načítavam...');
          Axios.get(SHMUconf.API_BASE_URL + 'meteo/getforecastweatherdata?station=' + this.selected_station_id, {
            crossDomain: true,
            cache: false,
          })
                  .then((response) => {
                    if (!response.data.error) {
                      self.stationData = response.data[0];
                      self.isDataLoaded = true;
                      self.lastUpdated = self.$moment().unix();
                      // clearInterval(this.tCheckInterval);
                      // this.tCheckInterval = setInterval(this.checkLastUpdated, 60*1000); // overujem kazdu minutu
                    } else {
                      self.$f7.dialog.alert('Nepodarilo sa načítať predpoveď počasia k stanici', 'Nastala chyba');
                    }
                    self.$f7.dialog.close();
                  }).catch((error) => {
            self.$f7.dialog.close();
            self.$f7.dialog.alert('Nepodarilo sa nadviazať spojenie so serverom SHMÚ', 'Nastala chyba spojenia');
          });
        }

      },
      checkLastUpdated() {
        if ((this.$moment().unix() - this.lastUpdated) > 5*60) { // ak posledne stiahnutie bolo pred vic ako 5 min, tak refresh
          this.pageReload(null, false);
        }
      },
      selectStationByLocation() {
        if (this.isGeolocationEnabled) {
          this.getGeoLocation(this.onLocationFoundAndSelectFirst, this.onLocationError)
        }
      },
      onLocationFoundAndSelectFirst(e) {
        this.currentLocation = e.coords;

        if (this.currentLocation !== null) {
          for (let i = 0; i < this.stations.length; i++) {
            this.stations[i]["distance"] = this.calculateDistance(
                this.currentLocation.latitude, this.currentLocation.longitude,
                this.stations[i]["gps_lat"], this.stations[i]["gps_lon"],"K").toFixed(2);
          }

          this.stations.sort(function(a, b) {
            return a.distance - b.distance;
          });

          this.selectedStationId = parseInt(this.stations[0].station_id);
          this.loadStationData();
          this.$ls.set('forecast_weather_station_id', this.selected_station_id);
          this.$f7.smartSelect.get('.predpoved-pocasia-ss-list .smart-select').setValue(this.selectedStationId);

        }
      },
      onLocationError(e) {
        this.locationError(this, e);
      },

    }

  };
</script>

<style lang="scss" scoped>
@import "./src/static/shmu/css/color";

  .tile {
    display: flex;
    flex-direction: column;;
    background-color: #fff;
    box-shadow: 0 5px 20px rgba(41, 61, 104, .15);
    .title {
      background-color: $pocasie-text;
      color: white;
      font-weight: bold;
      text-align: center;
      font-size: 21px;
      padding: 5px 0px;
      line-height: 20px;
      .small {
        font-weight: normal;
        font-size: 0.8em;
      }

    }

    .wind {
      text-align: center;
      padding: 5px 0px;
      width: 100%;
      .img-wind {
        vertical-align: middle;
        width: 25px;

        &.rot-prem {
          animation: kmitaj-prem 4s linear infinite;
        }

        &.rot-j {
          transform: rotate(-90deg);
          animation: kmitaj-j 2s ease-in-out infinite;

        }

        &.rot-s {
          transform: rotate(90deg);
          animation: kmitaj-s 2s ease-in-out infinite;

        }

        &.rot-v {
          transform: rotate(180deg);
          animation: kmitaj-v 2s ease-in-out infinite;

        }

        &.rot-z {
          transform: rotate(0deg);
          animation: kmitaj-z 2s ease-in-out infinite;

        }

        &.rot-jv {
          transform: rotate(225deg);
          animation: kmitaj-jv 2s ease-in-out infinite;

        }

        &.rot-jz {
          transform: rotate(-45deg);
          animation: kmitaj-jz 2s ease-in-out infinite;

        }

        &.rot-sv {
          transform: rotate(135deg);
          animation: kmitaj-sv 2s ease-in-out infinite;

        }

        &.rot-sz {
          transform: rotate(45deg);
          animation: kmitaj-sz 2s ease-in-out infinite;

        }



      }
    }

    .temps {
      display:flex;
      flex-direction: row;
      width: 100%;
      justify-content: center;
      flex-wrap: nowrap;
      align-content: flex-start;

      div {
        /* width: 50%; */
        flex-grow: 1;
        flex-basis: 0;
        text-align: center;
        font-weight: bold;
        font-size: 28px;
        line-height:24px;
        border-top: 1px solid black;
        padding: 0px 0px 8px 0px;
        .small {
          font-weight: normal;
          font-size: 0.6em;
        }

      }
      .temp_black {
        background-color: black;
        color: white;
      }
      .temp_white {
        background-color: white;
        color: black;
        border-left: 1px solid black;

      }
    }
  }



  .icons-group.multi {
    height: 260px;
    .icon {
      zoom: 1.5;
    }
    .title {
      font-size: 20px;
    }
    .temps {
      div {
        font-size: 20px;
      }
    }
  }


</style>

<style lang="scss">

  .predpoved-pocasia-main {
    max-width: 350px;
    margin:1rem auto;
    .block-strong {
      &:before {
        display:none;
      }
      &:last-child {
        &:after {
          display:none;
        }
      }
    }
  }
  .predpoved-icon-size {
    width: 120px;
    height: 120px;
  }

  .predpoved-ttmax,
  .predpoved-ttmin,
  {
    text-align: center;
    border: 1px solid var(--f7-list-border-color);
    padding: 3px 7px;
    font-weight: bold;
    font-size:20px;
  }

  .predpoved-cards {
    .card {
      max-width: 350px;
    }
  }


</style>
